/**
 * Date-extensions locale Scottish Gaelic [gd]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('gd', {
    monthNames: ['Am Faoilleach','An Gearran','Am Màrt','An Giblean','An Cèitean','An t-Ògmhios','An t-Iuchar','An Lùnastal','An t-Sultain','An Dàmhair','An t-Samhain','An Dùbhlachd'],
    monthShortNames: ['Faoi','Gear','Màrt','Gibl','Cèit','Ògmh','Iuch','Lùn','Sult','Dàmh','Samh','Dùbh'],
    dayNames: ['Didòmhnaich','Diluain','Dimàirt','Diciadain','Diardaoin','Dihaoine','Disathairne'],
    dayShortNames: ['Did','Dil','Dim','Dic','Dia','Dih','Dis']
});
